import invert from 'invert-color';

import { DEFAULT_TEXT_ZOOM } from './app.const';

import gradient from '../styles/gradient.module.scss';

export const GRADIENT = {
  gradientPeriwinkle: gradient.periwinkle,
};

export const PALETTE = {
  beige100: '#F6F2E8',
  black: '#000000',
  blue300: '#3975EA',
  blue400: '#2563EB',
  brown400: '#221302',
  green400: '#059669',
  neutral100: '#F3F4F6',
  neutral200: '#E5E7EB',
  neutral300: '#D1D5DB',
  neutral400: '#9CA3AF',
  neutral50: '#F9FAFB',
  neutral500: '#6B7280',
  neutral600: '#D9D9D9',
  neutral700: '#4B5563',
  neutral800: '#757575',
  orange100: '#FFEFD6',
  orange200: '#FFDDA9',
  orange300: '#FCBC5B',
  orange400: '#F4A226',
  periwinkle100: '#EBEEFD',
  periwinkle200: '#D1D8FC',
  periwinkle300: '#A8B4F2',
  periwinkle400: '#8395EE',
  periwinkle500: '#5D61D8',
  red400: '#DC2626',
  red500: '#EF4444',
  transparent: 'transparent',
  white100: '#FFFFFF',
  yellow100: '#FFFBDC',
  yellow400: '#FFF392',
};

export const THEME = {
  isDesktop: false,
  isTablet: false,
  isMobile: false,
  textZoom: DEFAULT_TEXT_ZOOM,
  fontSize: (value: number) => {
    return `${THEME.textZoom * (value / 16)}rem`;
  },
  invert: (color: string, bw?: { black: string; white: string } | boolean) =>
    invert(color, bw || true),
  spacing: (v: number) => `${v * 4}px`,
  palette: PALETTE,
  gradient: GRADIENT,
};
